import { render, staticRenderFns } from "./PODView.vue?vue&type=template&id=bb34a3b2&scoped=true&"
import script from "./PODView.vue?vue&type=script&lang=js&"
export * from "./PODView.vue?vue&type=script&lang=js&"
import style0 from "./PODView.vue?vue&type=style&index=0&id=bb34a3b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb34a3b2",
  null
  
)

export default component.exports